export const SUPPORTED_LOCALES = ['ca', 'es', 'en'];
export const DEFAULT_LOCALE = 'ca';

export function normalizeLang (raw) {
  if (!raw || typeof raw !== 'string') return DEFAULT_LOCALE;
  const base = raw.split(/[-_]/)[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(base) ? base : DEFAULT_LOCALE;
}

export default {
  ca: {
    app: {
      title: 'Transformació de Fitxers',
      subtitle: 'Prepara un fitxer extern per carregar-lo a Sherpa',
    },
    nav: {
      upload: '1 · Càrrega',
      audit: '2 · Auditoria',
      form: '3 · Formulari',
      mapping: '4 · Mapeig',
      values: '5 · Valors',
      correction: '6 · Correcció',
      computed: '7 · Camps calculats',
      export: '8 · Exportació',
    },
    upload: {
      drop: 'Arrossega aquí un fitxer CSV o XLSX',
      or: 'o',
      browse: 'Selecciona un fitxer',
      loaded: 'Fitxer carregat',
      change: 'Canvia el fitxer',
      encoding: 'Codificació',
      encodingAuto: 'detectada',
      delimiter: 'Separador',
      delimiterAuto: 'Auto',
      multiSeparator: 'Separador multiresposta',
      multiSeparatorAuto: 'Auto',
      encodingPick: '— tria la codificació —',
      encodingUnknown: 'No s\'ha pogut detectar la codificació del fitxer. Tria-la manualment per poder continuar.',
      analyze: 'Analitza el fitxer',
      reset: 'Reinicia',
      analyzing: 'Analitzant el fitxer…',
      phaseReading: 'Llegint el fitxer',
      phaseParsing: 'Interpretant el fitxer',
      phaseFields: 'Analitzant els camps',
      phaseGrouping: 'Agrupació semàntica',
      rowsUnit: 'files',
      noData: 'El fitxer no conté dades (capçalera + files).',
      xlsxLarge: 'Aquest XLSX és gran ({mb} MB). Processar Excel al navegador és lent i pot fallar; per a fitxers grans, exporta\'l a CSV (molt més ràpid).',
      xlsxTooBig: 'No s\'ha pogut llegir aquest XLSX al navegador (probablement massa gran). Exporta\'l a CSV i torna-ho a provar.',
      formats: 'Formats acceptats: .csv, .xlsx (fins ~50.000 files)',
    },
    audit: {
      summary: 'Resum general',
      records: 'Registres',
      fields: 'Camps',
      groups: 'Agrupació semàntica',
      perField: 'Descriptiu per camp',
      download: 'Descarrega l\'informe Excel',
      none: 'Encara no hi ha cap fitxer carregat',
      type: 'Tipus',
      informed: 'Informats',
      nulls: 'Nuls',
      unique: 'Únics',
      sample: 'Mostra de valors',
      moreSample: 'i {count} valors més',
      typeEmpty: 'Buit',
      typeBoolean: 'Booleà',
      typeNumber: 'Número',
      typeDate: 'Data',
      typeEmail: 'Email',
      typeText: 'Text',
      typeMixed: 'Barrejat',
    },
    form: {
      title: 'Selecciona el formulari de destí',
      search: 'Cerca pel nom del formulari',
      load: 'Carrega la definició',
      definition: 'Definició del formulari',
      noDefinition: 'Selecciona un formulari per veure la seva definició',
      mandatory: 'Obligatori',
      optional: 'Opcional',
      fromBackend: 'Des del backend Sherpa',
      fromFile: 'Des d\'un fitxer XLSX',
      responses: 'respostes',
      loadLang: 'Idioma de càrrega',
      pickLang: '— Tria un idioma —',
      pickLangHint: 'Tria l\'idioma per carregar la definició i continuar',
      pickLangFirst: 'Primer tria l\'idioma de càrrega',
      noBackend: 'No es pot accedir al backend de Sherpa.',
      envHint: 'Comprova la connexió a Sherpa (URL i token) a la barra de Configuració; els formularis es carreguen des de Sherpa.',
      fileHint: 'Carrega l\'XLSX descarregat des de Sherpa amb la definició del formulari (full "Definición de los campos").',
      pickFile: 'Selecciona el fitxer XLSX',
      loaded: 'Carregat:',
      colLabel: 'Etiqueta',
      colType: 'Tipus',
      colMinMax: 'Mín / Màx',
      colFormat: 'Format',
      colValidResponses: 'Respostes vàlides',
      errAuthRequired: 'Autenticació requerida',
      errCheckTokenAt: 'comprova el token a ⚙ Configuració',
    },
    mapping: {
      refresh: '↻ Refés proposta',
      needsPrev: 'Cal carregar un fitxer i seleccionar un formulari abans de mapejar.',
      fileColumns: 'Columnes fitxer',
      mapped: 'Mapejades',
      confHigh: 'Alta',
      confMedium: 'Mitjana',
      confLow: 'Baixa',
      confNone: 'Sense',
      filter: 'Filtra per columna o camp destí',
      onlyUnmapped: 'només sense mapeig',
      colColumn: 'Columna fitxer',
      colField: 'Camp definició',
      colConfidence: 'Confiança',
      colAction: 'Acció',
      colValidation: 'Validació',
      missingMandatory: 'Camps obligatoris sense origen al fitxer ({n})',
      missingMandatoryHint: 'Cap columna del fitxer es mapeja a aquests camps obligatoris. Has de fixar un valor per a tots els registres: sense valor, la càrrega a Sherpa fallarà.',
      defaultModeNone: '—',
      defaultModeAuto: 'Valor automàtic',
      autoValuePlaceholder: 'valor automàtic',
      pickValue: '— tria un valor —',
      fixedValuePlaceholder: 'valor per a tots els registres',
      fillRequiredFirst: 'Omple tots els camps obligatoris sense origen abans de continuar',
      requiredIncomplete: 'Falten {n} camps obligatoris per assignar un valor.',
      missingOptional: 'Camps opcionals sense origen al fitxer ({n})',
      missingOptionalHint: 'Aquests camps del formulari no es mapegen a cap columna. Si vols pots fixar-hi un valor per a tots els registres; si els deixes buits, simplement no s\'ompliran.',
      noMapping: '— sense mapeig —',
      searchField: 'Cerca camp…',
      rowMandatory: 'obligatori',
      rowDomain: 'domini {n}',
      ignoreColumn: 'Ignorar columna',      errors: '{n} errors',
    },
    values: {
      proposeAuto: '✨ Proposa automàticament',
      propose: '✨ Proposa',
      needsPrev: 'Cal completar els passos previs (Càrrega, Formulari, Mapeig).',
      noClosedDomains: 'Cap dels camps mapejats té un domini tancat. No cal assignar valors.',
      fieldsWithDomain: 'Camps amb domini',
      uniqueValues: 'Valors únics',
      alreadyValid: 'Ja vàlids',
      assigned: 'Assignats',
      pending: 'Pendents',
      filter: 'Filtra per camp o valor',
      hideValid: 'oculta valors ja vàlids',
      onlyWithPending: 'només camps amb pendents',
      sourceColumn: '· columna origen:',
      clearAssignments: 'Neteja assignacions',
      allowedValues: 'Valors permesos:',
      colOriginal: 'Valor original',
      colRepetitions: 'Repeticions',
      colState: 'Estat',
      colAssignedTo: 'Assignat a',
      alreadyValidState: '— ja vàlid —',
      unassigned: '— sense assignar —',
      stateValid: 'vàlid',
      stateAssigned: 'assignat',
      statePending: 'pendent',
      noPendingValue: '— Cap valor pendent —',
    },
    correction: {
      recalculate: '↻ Recalcula propostes',
      pipelineTitle: 'Pipeline de correcció',
      programErrors: 'Errors dels programes',
      needsPrev: 'Cal completar els passos previs (Càrrega, Auditoria, Formulari, Mapeig).',
      rulesApplied: 'Regles aplicades',
      affectsAll: 'Afecta: tots els camps mapejats',
      affectsByType: 'Afecta (per tipus):',
      affectsByAlias: 'Afecta:',
      affectsNone: 'Afecta: cap camp d\'aquest formulari',
      programsHint: 'Programes de neteja del catàleg de Sherpa. Activa o desactiva els que vulguis aplicar.',
      restoreDefault: 'Restaura per defecte',
      pressRecalculate: 'Prem «Recalcula propostes» per generar les correccions automàtiques.',
      rulesNote: 'El motor només aplica les regles que tens marcades aquí dalt. Pots desmarcar-ne qualsevol si no la vols fer servir per a aquesta execució; la preferència es desa al navegador per als pròxims fitxers.',
      proposals: 'Propostes',
      accepted: 'Acceptades',
      rejected: 'Rebutjades',
      filter: 'Filtra per camp, valor o estratègia',
      allStrategies: 'Totes les estratègies',
      showRejected: 'mostra rebutjades',
      acceptVisible: '✓ Accepta visibles',
      rejectVisible: '✕ Rebutja visibles',
      afterApply: 'Després d\'aplicar les correccions acceptades:',
      rowsWithErrors: 'Files amb errors',
      totalErrors: 'Total errors',
      colStrategy: 'Estratègia',
      strategyMove: 'MOURE',
      strategySwap: 'INTERCANVIA',
      strategyReview: 'REVISIÓ',
      stepGeneric: 'Correccions generals',
      stepGenericHint: 'S\'apliquen a tots els camps (espais, format, reubicació entre columnes).',
      stepField: 'Correccions de camp',
      stepFieldHint: 'S\'apliquen només a camps concrets segons el seu àlies (p. ex. email), sobre les dades ja passades pel pas general.',
      colStep: 'Pas',
      allSteps: 'Tots els passos',
      ruleTrim: 'Neteja d\'espais',
      ruleTrimDesc: 'Elimina espais inicials/finals, col·lapsa espais múltiples i treu caràcters Unicode invisibles (BOM, zero-width).',
      ruleProperName: 'NomPropi (majúscules/minúscules)',
      ruleProperNameDesc: 'Converteix text tot en majúscules o tot en minúscules a format NomPropi (JUAN PEREZ → Juan Perez). No toca text ja barrejat.',
      ruleDateFormat: 'Format de data',
      ruleDateFormatDesc: 'Converteix dates entre formats (ISO, europeu dd/MM/yyyy, etc.) al patró que demana el camp.',
      ruleDomainMatch: 'Match aproximat de domini',
      ruleDomainMatchDesc: 'Cerca el valor més proper en un domini tancat usant prefix/sufix/Levenshtein (corregeix errates com Tonsumer → consumer, profe → professional).',
      ruleRelocate: 'Reubicació entre camps',
      ruleRelocateDesc: 'Detecta valors situats al camp incorrecte (per exemple un email al camp telèfon) i proposa moure\'ls al camp correcte si la cel·la destí és buida. Si el destí ja té valor, només es marca per a revisió manual.',
      alreadyHasValue: '(ja té valor)',
      swapValueLabel: 'valor:',
      noProposals: '— Cap proposta amb aquests filtres —',
      showingPagination: 'Mostrant {visible} de {total} ({hidden} ocultes per paginació).',
    },
    computed: {
      recalculate: '↻ Recalcula',
      pipelineTitle: 'Pipeline de càlcul',
      showTechLog: 'Mostra el log tècnic',
      pipeline: {
        proposals: 'propostes',
        queued: 'en cua',
        runningNow: 'en curs…',
        skipped: 'desactivat',
        inProgress: 'en curs',
        done: 'fet',
        typePreprocess: 'preprocés',
        typeCompute: 'càlcul',
        typeCorrection: 'correcció',
      },
      recalculatePending: '↻ Recalcula (pendent)',
      running: 'Executant…',
      runningAtomic: 'Processant…',
      console: "Consola d'execució",
      clearConsole: 'Neteja',
      cantLeaveWhileRunning: "No es pot passar al següent pas mentre s'executen els programes. Espera que acabin.",
      needsPrev: 'Cal completar els passos previs (Càrrega, Formulari, Mapeig).',
      programsAvailable: 'Programes disponibles',
      configChanged: 'Configuració canviada · prem <strong>Recalcula</strong>',
      noCalculator: 'Cap calculadora disponible.',
      restoreDefaultShort: 'restaura defecte',
      requiredFields: 'Camps requerits:',
      pickFieldHint: 'Tria un camp per a cada selector perquè el càlcul s\'apliqui.',
      pressRecalculate: 'Prem «Recalcula» per generar les propostes.',
      basedOnCorrection: 'Es treballa sobre el resultat del pas de Correcció. Pots tornar enrere si vols ajustar mapejos o regles.',
      proposals: 'Propostes',
      accepted: 'Acceptades',
      rejected: 'Rebutjades',
      filter: 'Filtra per camp, valor, motiu o calculadora',
      allCalculators: 'Totes les calculadores',
      showRejected: 'mostra rebutjades',
      acceptVisible: '✓ Accepta visibles',
      rejectVisible: '✕ Rebutja visibles',
      afterAccepted: 'Després d\'aplicar els càlculs acceptats:',
      rowsWithErrors: 'Files amb errors',
      totalErrors: 'Total errors',
      changesSummary: 'Resum de canvis',
      changesSummaryHint: 'Les propostes acceptades agrupades per programa i tipus de canvi (mateix camp i mateixos valors). Visió de conjunt; el detall fila a fila és a «Propostes».',
      proposalsHint: 'Taula principal: cada canvi proposat, fila a fila, amb el motiu i la casella per acceptar-lo o rebutjar-lo. El «Resum de canvis» de dalt n\'és la versió agregada (plegada).',
      colProgram: 'Programa',
      byProgram: 'Per programa:',
      fromProgram: 'Programa:',
      typePreprocess: 'Preprocés',
      typeCompute: 'Càlcul',
      colRows: 'Files',
      noEntries: '— Cap entrada amb aquest filtre —',
      showMore: 'Mostra\'n més',
      colRow: 'Fila',
      colField: 'Camp',
      colOriginal: 'Original',
      colProposed: 'Proposat',
      colDataOrigin: 'Dades origen',
      colDataOutput: 'Dades de sortida',
      colReason: 'Motiu',
      colAccept: 'Accepta',
      showingProposals: 'Mostrant {visible} de {total} ({hidden} ocultes per paginació).',
      copied: '✓ Copiat',
      copyError: '✗ Error',
      copy: '📋 Copia',
    },
    export: {
      needsPrev: 'Cal completar els passos previs (carregar fitxer, seleccionar formulari i mapejar).',
      rows: 'Files',
      rowsWithErrors: 'Files amb errors',
      totalErrors: 'Total errors',
      errorsDetected: 'Errors detectats (primeres {n} files)',
      colRow: 'Fila',
      colField: 'Camp',
      colCode: 'Codi',
      colValue: 'Valor',
      colExpected: 'Esperat',
      downloadXlsx: '⬇ Descarrega XLSX transformat',
      uploadToSherpa: '☁ Carrega a Sherpa',
      uploading: 'Pujant…',
      colMessage: 'Què falla',
      moreCount: '… (+{n} més)',
      uploadOK: 'Càrrega completada',
      uploadError: 'Error en la càrrega',
      validate: '✓ Validar a Sherpa',
      validating: 'Validant…',
      save: '☁ Guardar a Sherpa',
      saving: 'Guardant…',
      revalidate: '↻ Tornar a validar',
      allValid: 'Tot validat correctament ({n} files). Pots guardar.',
      serverErrors: 'Errors de validació ({n})',
      serverErrorsHint: 'Corregeix els valors aquí i torna a validar. No es guardarà res fins que no hi hagi cap error.',
      editsCount: '{n} correccions',
      precheck: 'Avís previ (validació local — primeres {n} files)',
      loadedOk: '✓ Carregades {n} respostes a Sherpa.',
      noRecords: 'No hi ha cap fila per validar/carregar (0 registres). Revisa el mapatge i les correccions: el resultat del pipeline és buit.',
      loadedWithErrors: 'La càrrega ha retornat {errors} error(s) del servidor (carregades {loaded}). Revisa els errors a sota.',
      loadStopped: 'La càrrega s\'ha aturat per un error: {msg}. No s\'ha reintentat (per no duplicar el ja carregat).',
      cantLeaveWhileRunning: 'No es pot sortir mentre s\'està validant o carregant.',
      logValidateStart: '▶ Validant {n} files a Sherpa…',
      logValidating: 'Validant files {from}–{to}…',
      logValidateOk: '✓ {n} files vàlides',
      logValidateErrors: '⚠ {n} errors de validació',
      logLoadStart: '▶ Carregant {n} files a Sherpa…',
      logLoading: 'Carregant files {from}–{to}…',
      flowTitle: 'Procés de càrrega',
      stageValidate: 'Validació',
      stageLoad: 'Càrrega',
      stageValidateIdle: 'Comprova al servidor que totes les files compleixen la definició del formulari.',
      stageValidateOk: '{n} files validades · cap error',
      stageValidateErrors: '{n} errors a corregir abans de guardar (taula a sota)',
      stageLoadLocked: 'Es desbloqueja quan la validació surti sense errors.',
      stageLoadReady: 'A punt per guardar {n} respostes a Sherpa.',
      techLog: 'Mostra el log tècnic',
      flowDone: 'Completat',
      colStatus: 'Estat',
      solvedCount: '{done} de {total} resolts',
      hideResolved: 'Amaga els resolts',
      resolved: 'Resolt',
      pendingLabel: 'Pendent',
      applySuggestion: 'Aplica aquest valor del domini',
      applyToSame: '↳ aplica a {n} iguals',
      applyToSameTitle: 'Aplica «{value}» a totes les files amb «{orig}» en aquest camp ({n} més)',
      repeatedTitle: 'Aquest mateix valor falla en {n} files més',
      errorsShowing: 'Mostrant {visible} de {total}',
      showMore: 'Mostra\'n més',
      downloadLoaded: '⬇ Excel del carregat',
      downloadExcel: '⬇ Descarrega Excel',
      downloadServerErrors: '⬇ Descarrega errors',
      excelError: 'No s\'ha pogut generar l\'Excel.',
    },
    common: {
      next: 'Següent',
      prev: 'Anterior',
      cancel: 'Cancel·la',
      yes: 'Sí',
      no: 'No',
      none: '—',
      exportCsv: 'Exporta CSV',
      showMore: 'Mostra\'n més',
      noEntries: '— Cap entrada amb aquest filtre —',
      copyShort: '📋',
      copiedShort: '✓',
      copyErrorShort: '✗',
      copied: 'Copiat',
      hide: 'Amaga',
      show: 'Mostra',
      hideArrow: '▼',
      showArrow: '▶',
    },
    programs: {
      originComponent: 'programa en local',
      originModel: 'programa del model',
    },
    progAbm: {
      open: 'Programes i dependències',
      title: 'Programes del component',
      close: 'Tanca',
      hint: 'Programes de correcció/càlcul guardats al projecte (standalonePrograms/). Es proven sense desar-los al model; quan validin, es promouen al catàleg del client.',
      newCorrection: 'Correcció', newCalculation: 'Càlcul',
      reload: 'Recarrega', empty: 'Encara no hi ha cap programa de component.',
      colName: 'Nom', colType: 'Tipus', colScope: 'Abast / àlies',
      edit: 'Edita', delete: 'Esborra', badSource: 'codi amb errors',
      fName: 'Nom (fitxer)', fNamePlaceholder: 'lletres, números, _ o -',
      fType: 'Tipus', fOrder: 'Ordre', fDescription: 'Descripció',
      fScope: 'Abast', fFieldTypes: 'Tipus de camp', fAliases: 'Àlies',
      fMatchAll: 'Coincidència d\'àlies', matchAny: 'ALGUN (n\'hi ha prou amb un)', matchAll: 'TOTS (tots han de ser-hi)',
      fAliasesPlaceholder: 'p.ex. individual_person_email, individual_person_name',
      fCode: 'Codi (mòdul JS: export default function create(ctx))',
      codeHint: 'Ha de ser autocontingut (sense imports). run(out, fields) retorna l’array de propostes.',
      cancel: 'Cancel·la', save: 'Desa',
      errName: 'El nom només pot tenir lletres, números, _ o -.',
      errCode: 'El codi no és vàlid: {msg}.',
      confirmDelete: 'Esborrar el programa «{name}»?',
      tabPrograms: 'Programes', tabDeps: 'Dependències',
      fDependencies: 'Dependències',
      depsEmpty: 'Cap dependència disponible (crea-les a la pestanya Dependències).',
      aliasesLoad: 'Carregar àlies del model', aliasesEmpty: 'Prem «Carregar àlies del model».',
      aliasesError: 'No s’han pogut carregar els àlies: {msg}',
      depsHint: 'Datasets/JS reutilitzables. Es carreguen a ctx.deps dels programes que les referencien (json → objecte, js → mòdul).',
      newDep: 'Dependència', depsEmptyList: 'Encara no hi ha cap dependència.',
      colDepType: 'Tipus', depContent: 'Contingut', errJson: 'JSON no vàlid: {msg}.',
      depLocal: 'local', depModel: 'model', readonly: 'només lectura',
    },
    settings: {
      title: 'Configuració de connexió a Sherpa',
      intro: 'Aquests valors es desen al navegador (localStorage). Tenen prioritat sobre el .env. Si poses una URL absoluta (https://…) es contacta directament; si la deixes buida es fa servir el proxy de Vite.',
      profile: 'Client',
      language: 'Idioma',
      tokenEmpty: 'definit al fitxer del client',
      tokenHelp: 'El bearer es defineix al fitxer del client (config/<client>/client.config.js, camp token). Canvia de client al selector per carregar el seu.',
      baseUrl: 'URL del backend',
      baseUrlHint: 'Exemple: https://el-teu-servidor/sherpa/service/',
      baseUrlPlaceholder: 'buit = proxy de dev → demo (sense CORS)',
      authScheme: 'Esquema d\'autenticació',
      authBearer: 'Authorization: Bearer …',
      authToken: 'Capçalera token: … (estil SherpaCRM)',
      authNone: 'Sense autenticació',
      token: 'Token',
      tokenPlaceholder: 'eyJhbGciOi…',
      version: 'Capçalera version',
      versionPlaceholder: '4.0.0',
      testPath: 'Ruta de prova',
      testPathHint: 'Endpoint que el botó «Prova connexió» visitarà (relatiu a la URL base). Per defecte: /forms.',
      testPathPlaceholder: 'ex: /forms o ruta-coneguda-del-teu-Sherpa',
      effective: 'Configuració activa',
      effectiveMode: 'mode',
      effectiveFinalUrl: 'URL final',
      effectiveAuth: 'auth',
      effectiveToken: 'token',
      effectiveVersion: 'version',
      tokenDefined: '✓ definit',
      tokenNotDefined: '— no definit',
      modeDirect: 'directe (URL absoluta)',
      modeProxy: 'proxy /sherpa-api de Vite',
      test: 'Prova connexió',
      save: 'Desa',
      clear: 'Esborra',
      show: 'Mostra',
      hide: 'Oculta',
      saved: 'Configuració desada al navegador.',
      cleared: 'Configuració local esborrada (es tornen a fer servir els valors de .env).',
      testItems: '{n} elements',
      testResponse: 'resposta rebuda',
      testOK: 'OK · status {status} · {summary}',
      testError: 'Error {code}{status} · {msg} · ruta provada: {path}{cors}',
      corsHint: 'possible CORS o URL incorrecta — comprova-ho a la consola del navegador',
    },
    swap: {
      title: '⇄ Possibles intercanvis detectats',
      hint: 'Sembla que aquestes columnes estan creuades — el contingut casa millor amb el camp del costat.',
      arrow: '↔',
      currently: 'actualment: {fieldA} ← {columnA}, {fieldB} ← {columnB}',
      swapping: 'intercanviant: {pAB}% + {pBA}% encaixen amb el camp creuat',
      swapButton: 'Intercanvia mapeig',
    },
    field: {
      closedDomain: 'domini tancat',
      smallSample: 'mostra petita',
      smallSampleTip: 'Pocs registres per decidir si el domini és tancat o obert; carrega més files per fiar-te\'n.',
      group: 'Grup:',
      copyTooltip: 'Copia el camp i la mostra al portapapers (TSV)',
      tsvFieldLabel: 'Camp',
      tsvTypeLabel: 'tipus',
      tsvGroupLabel: 'grup',
      tsvFilledLabel: 'informats',
      tsvNullsLabel: 'nuls',
      tsvUniqueLabel: 'únics',
      tsvClosedLabel: 'domini tancat',
      tsvHeader: 'VALOR\tCOUNT',
    },
  },
  es: {
    app: {
      title: 'Transformación de Ficheros',
      subtitle: 'Prepara un fichero externo para cargarlo a Sherpa',
    },
    nav: {
      upload: '1 · Carga',
      audit: '2 · Auditoría',
      form: '3 · Formulario',
      mapping: '4 · Mapeo',
      values: '5 · Valores',
      correction: '6 · Corrección',
      computed: '7 · Campos calculados',
      export: '8 · Exportación',
    },
    upload: {
      drop: 'Arrastra aquí un fichero CSV o XLSX',
      or: 'o',
      browse: 'Selecciona un fichero',
      loaded: 'Archivo cargado',
      change: 'Cambia el archivo',
      encoding: 'Codificación',
      encodingAuto: 'detectada',
      delimiter: 'Separador',
      delimiterAuto: 'Auto',
      multiSeparator: 'Separador multirespuesta',
      multiSeparatorAuto: 'Auto',
      encodingPick: '— elige la codificación —',
      encodingUnknown: 'No se ha podido detectar la codificación del fichero. Selecciónala manualmente para poder continuar.',
      analyze: 'Analizar el fichero',
      reset: 'Reiniciar',
      analyzing: 'Analizando el fichero…',
      phaseReading: 'Leyendo el fichero',
      phaseParsing: 'Interpretando el fichero',
      phaseFields: 'Analizando los campos',
      phaseGrouping: 'Agrupación semántica',
      rowsUnit: 'filas',
      noData: 'El fichero no contiene datos (cabecera + filas).',
      xlsxLarge: 'Este XLSX es grande ({mb} MB). Procesar Excel en el navegador es lento y puede fallar; para ficheros grandes, expórtalo a CSV (mucho más rápido).',
      xlsxTooBig: 'No se ha podido leer este XLSX en el navegador (probablemente demasiado grande). Expórtalo a CSV e inténtalo de nuevo.',
      formats: 'Formatos aceptados: .csv, .xlsx (hasta ~50.000 filas)',
    },
    audit: {
      summary: 'Resumen general',
      records: 'Registros',
      fields: 'Campos',
      groups: 'Agrupación semántica',
      perField: 'Descriptivo por campo',
      download: 'Descargar el informe Excel',
      none: 'Aún no hay ningún fichero cargado',
      type: 'Tipo',
      informed: 'Informados',
      nulls: 'Nulos',
      unique: 'Únicos',
      sample: 'Muestra de valores',
      moreSample: 'y {count} valores más',
      typeEmpty: 'Vacío',
      typeBoolean: 'Booleano',
      typeNumber: 'Número',
      typeDate: 'Fecha',
      typeEmail: 'Email',
      typeText: 'Texto',
      typeMixed: 'Mezclado',
    },
    form: {
      title: 'Selecciona el formulario de destino',
      search: 'Busca por nombre de formulario',
      load: 'Cargar la definición',
      definition: 'Definición del formulario',
      noDefinition: 'Selecciona un formulario para ver su definición',
      mandatory: 'Obligatorio',
      optional: 'Opcional',
      fromBackend: 'Desde el backend Sherpa',
      fromFile: 'Desde un fichero XLSX',
      responses: 'respuestas',
      loadLang: 'Idioma de carga',
      pickLang: '— Elige un idioma —',
      pickLangHint: 'Elige el idioma para cargar la definición y continuar',
      pickLangFirst: 'Primero elige el idioma de carga',
      noBackend: 'No se puede acceder al backend de Sherpa.',
      envHint: 'Comprueba la conexión a Sherpa (URL y token) en la barra de Configuración; los formularios se cargan desde Sherpa.',
      fileHint: 'Carga el XLSX descargado desde Sherpa con la definición del formulario (hoja "Definición de los campos").',
      pickFile: 'Selecciona el fichero XLSX',
      loaded: 'Cargado:',
      colLabel: 'Etiqueta',
      colType: 'Tipo',
      colMinMax: 'Mín / Máx',
      colFormat: 'Formato',
      colValidResponses: 'Respuestas válidas',
      errAuthRequired: 'Autenticación requerida',
      errCheckTokenAt: 'comprueba el token en ⚙ Configuración',
    },
    mapping: {
      refresh: '↻ Rehacer propuesta',
      needsPrev: 'Hay que cargar un fichero y seleccionar un formulario antes de mapear.',
      fileColumns: 'Columnas fichero',
      mapped: 'Mapeadas',
      confHigh: 'Alta',
      confMedium: 'Media',
      confLow: 'Baja',
      confNone: 'Sin',
      filter: 'Filtra por columna o campo destino',
      onlyUnmapped: 'solo sin mapeo',
      colColumn: 'Columna fichero',
      colField: 'Campo definición',
      colConfidence: 'Confianza',
      colAction: 'Acción',
      colValidation: 'Validación',
      missingMandatory: 'Campos obligatorios sin origen en el fichero ({n})',
      missingMandatoryHint: 'Ninguna columna del fichero se mapea a estos campos obligatorios. Debes fijar un valor para todos los registros: sin valor, la carga en Sherpa fallará.',
      defaultModeNone: '—',
      defaultModeAuto: 'Valor automático',
      autoValuePlaceholder: 'valor automático',
      pickValue: '— elige un valor —',
      fixedValuePlaceholder: 'valor para todos los registros',
      fillRequiredFirst: 'Rellena todos los campos obligatorios sin origen antes de continuar',
      requiredIncomplete: 'Faltan {n} campos obligatorios por asignar un valor.',
      missingOptional: 'Campos opcionales sin origen en el fichero ({n})',
      missingOptionalHint: 'Estos campos del formulario no se mapean a ninguna columna. Si quieres puedes fijarles un valor para todos los registros; si los dejas vacíos, simplemente no se rellenarán.',
      noMapping: '— sin mapeo —',
      searchField: 'Buscar campo…',
      rowMandatory: 'obligatorio',
      rowDomain: 'dominio {n}',
      ignoreColumn: 'Ignorar columna',      errors: '{n} errores',
    },
    values: {
      proposeAuto: '✨ Proponer automáticamente',
      propose: '✨ Proponer',
      needsPrev: 'Hay que completar los pasos previos (Carga, Formulario, Mapeo).',
      noClosedDomains: 'Ninguno de los campos mapeados tiene un dominio cerrado. No hace falta asignar valores.',
      fieldsWithDomain: 'Campos con dominio',
      uniqueValues: 'Valores únicos',
      alreadyValid: 'Ya válidos',
      assigned: 'Asignados',
      pending: 'Pendientes',
      filter: 'Filtra por campo o valor',
      hideValid: 'oculta valores ya válidos',
      onlyWithPending: 'solo campos con pendientes',
      sourceColumn: '· columna origen:',
      clearAssignments: 'Limpiar asignaciones',
      allowedValues: 'Valores permitidos:',
      colOriginal: 'Valor original',
      colRepetitions: 'Repeticiones',
      colState: 'Estado',
      colAssignedTo: 'Asignado a',
      alreadyValidState: '— ya válido —',
      unassigned: '— sin asignar —',
      stateValid: 'válido',
      stateAssigned: 'asignado',
      statePending: 'pendiente',
      noPendingValue: '— Sin valor pendiente —',
    },
    correction: {
      recalculate: '↻ Recalcular propuestas',
      pipelineTitle: 'Pipeline de corrección',
      programErrors: 'Errores de los programas',
      needsPrev: 'Hay que completar los pasos previos (Carga, Auditoría, Formulario, Mapeo).',
      rulesApplied: 'Reglas aplicadas',
      affectsAll: 'Afecta: todos los campos mapeados',
      affectsByType: 'Afecta (por tipo):',
      affectsByAlias: 'Afecta:',
      affectsNone: 'Afecta: ningún campo de este formulario',
      programsHint: 'Programas de limpieza del catálogo de Sherpa. Activa o desactiva los que quieras aplicar.',
      restoreDefault: 'Restablecer por defecto',
      pressRecalculate: 'Pulsa «Recalcular propuestas» para generar las correcciones automáticas.',
      rulesNote: 'El motor solo aplica las reglas que tienes marcadas aquí arriba. Puedes desmarcar cualquiera si no la quieres usar para esta ejecución; la preferencia se guarda en el navegador para los próximos ficheros.',
      proposals: 'Propuestas',
      accepted: 'Aceptadas',
      rejected: 'Rechazadas',
      filter: 'Filtra por campo, valor o estrategia',
      allStrategies: 'Todas las estrategias',
      showRejected: 'mostrar rechazadas',
      acceptVisible: '✓ Aceptar visibles',
      rejectVisible: '✕ Rechazar visibles',
      afterApply: 'Después de aplicar las correcciones aceptadas:',
      rowsWithErrors: 'Filas con errores',
      totalErrors: 'Total errores',
      colStrategy: 'Estrategia',
      strategyMove: 'MOVER',
      strategySwap: 'INTERCAMBIAR',
      strategyReview: 'REVISIÓN',
      stepGeneric: 'Correcciones generales',
      stepGenericHint: 'Se aplican a todos los campos (espacios, formato, reubicación entre columnas).',
      stepField: 'Correcciones de campo',
      stepFieldHint: 'Se aplican solo a campos concretos según su alias (p. ej. email), sobre los datos ya pasados por el paso general.',
      colStep: 'Paso',
      allSteps: 'Todos los pasos',
      ruleTrim: 'Limpieza de espacios',
      ruleTrimDesc: 'Elimina espacios iniciales/finales, colapsa espacios múltiples y quita caracteres Unicode invisibles (BOM, zero-width).',
      ruleProperName: 'NombrePropio (mayúsculas/minúsculas)',
      ruleProperNameDesc: 'Convierte texto todo en mayúsculas o todo en minúsculas a formato NombrePropio (JUAN PEREZ → Juan Perez). No toca texto ya mezclado.',
      ruleDateFormat: 'Formato de fecha',
      ruleDateFormatDesc: 'Convierte fechas entre formatos (ISO, europeo dd/MM/yyyy, etc.) al patrón que pide el campo.',
      ruleDomainMatch: 'Match aproximado de dominio',
      ruleDomainMatchDesc: 'Busca el valor más cercano en un dominio cerrado usando prefijo/sufijo/Levenshtein (corrige erratas como Tonsumer → consumer, profe → professional).',
      ruleRelocate: 'Reubicación entre campos',
      ruleRelocateDesc: 'Detecta valores situados en el campo incorrecto (por ejemplo un email en el campo teléfono) y propone moverlos al campo correcto si la celda destino está vacía. Si el destino ya tiene valor, sólo se marca para revisión manual.',
      alreadyHasValue: '(ya tiene valor)',
      swapValueLabel: 'valor:',
      noProposals: '— Sin propuestas con estos filtros —',
      showingPagination: 'Mostrando {visible} de {total} ({hidden} ocultas por paginación).',
    },
    computed: {
      recalculate: '↻ Recalcular',
      pipelineTitle: 'Pipeline de cálculo',
      showTechLog: 'Mostrar el log técnico',
      pipeline: {
        proposals: 'propuestas',
        queued: 'en cola',
        runningNow: 'en curso…',
        skipped: 'desactivado',
        inProgress: 'en curso',
        done: 'hecho',
        typePreprocess: 'preproceso',
        typeCompute: 'cálculo',
        typeCorrection: 'corrección',
      },
      recalculatePending: '↻ Recalcular (pendiente)',
      running: 'Ejecutando…',
      runningAtomic: 'Procesando…',
      console: 'Consola de ejecución',
      clearConsole: 'Limpiar',
      cantLeaveWhileRunning: 'No se puede pasar al siguiente paso mientras se ejecutan los programas. Espera a que terminen.',
      needsPrev: 'Hay que completar los pasos previos (Carga, Formulario, Mapeo).',
      programsAvailable: 'Programas disponibles',
      configChanged: 'Configuración modificada · pulsa <strong>Recalcular</strong>',
      noCalculator: 'No hay calculadora disponible.',
      restoreDefaultShort: 'restaurar por defecto',
      requiredFields: 'Campos requeridos:',
      pickFieldHint: 'Elige un campo para cada selector para que el cálculo se aplique.',
      pressRecalculate: 'Pulsa «Recalcular» para generar las propuestas.',
      basedOnCorrection: 'Se trabaja sobre el resultado del paso de Corrección. Puedes volver atrás si quieres ajustar mapeos o reglas.',
      proposals: 'Propuestas',
      accepted: 'Aceptadas',
      rejected: 'Rechazadas',
      filter: 'Filtra por campo, valor, motivo o calculadora',
      allCalculators: 'Todas las calculadoras',
      showRejected: 'mostrar rechazadas',
      acceptVisible: '✓ Aceptar visibles',
      rejectVisible: '✕ Rechazar visibles',
      afterAccepted: 'Después de aplicar los cálculos aceptados:',
      rowsWithErrors: 'Filas con errores',
      totalErrors: 'Total errores',
      changesSummary: 'Resumen de cambios',
      changesSummaryHint: 'Las propuestas aceptadas agrupadas por programa y tipo de cambio (mismo campo y mismos valores). Visión de conjunto; el detalle fila a fila está en «Propuestas».',
      proposalsHint: 'Tabla principal: cada cambio propuesto, fila a fila, con el motivo y la casilla para aceptarlo o rechazarlo. El «Resumen de cambios» de arriba es su versión agregada (plegada).',
      colProgram: 'Programa',
      byProgram: 'Por programa:',
      fromProgram: 'Programa:',
      typePreprocess: 'Preproceso',
      typeCompute: 'Cálculo',
      colRows: 'Filas',
      noEntries: '— Sin entradas con este filtro —',
      showMore: 'Mostrar más',
      colRow: 'Fila',
      colField: 'Campo',
      colOriginal: 'Original',
      colProposed: 'Propuesto',
      colDataOrigin: 'Datos origen',
      colDataOutput: 'Datos de salida',
      colReason: 'Motivo',
      colAccept: 'Aceptar',
      showingProposals: 'Mostrando {visible} de {total} ({hidden} ocultas por paginación).',
      copied: '✓ Copiado',
      copyError: '✗ Error',
      copy: '📋 Copiar',
    },
    export: {
      needsPrev: 'Hay que completar los pasos previos (cargar fichero, seleccionar formulario y mapear).',
      rows: 'Filas',
      rowsWithErrors: 'Filas con errores',
      totalErrors: 'Total errores',
      errorsDetected: 'Errores detectados (primeras {n} filas)',
      colRow: 'Fila',
      colField: 'Campo',
      colCode: 'Código',
      colValue: 'Valor',
      colExpected: 'Esperado',
      downloadXlsx: '⬇ Descargar XLSX transformado',
      uploadToSherpa: '☁ Cargar a Sherpa',
      uploading: 'Cargando…',
      colMessage: 'Qué falla',
      moreCount: '… (+{n} más)',
      uploadOK: 'Carga completada',
      uploadError: 'Error en la carga',
      validate: '✓ Validar en Sherpa',
      validating: 'Validando…',
      save: '☁ Guardar en Sherpa',
      saving: 'Guardando…',
      revalidate: '↻ Volver a validar',
      allValid: 'Todo validado correctamente ({n} filas). Puedes guardar.',
      serverErrors: 'Errores de validación ({n})',
      serverErrorsHint: 'Corrige los valores aquí y vuelve a validar. No se guardará nada hasta que no haya ningún error.',
      editsCount: '{n} correcciones',
      precheck: 'Aviso previo (validación local — primeras {n} filas)',
      loadedOk: '✓ Cargadas {n} respuestas en Sherpa.',
      noRecords: 'No hay ninguna fila para validar/cargar (0 registros). Revisa el mapeo y las correcciones: el resultado del pipeline está vacío.',
      loadedWithErrors: 'La carga ha devuelto {errors} error(es) del servidor (cargadas {loaded}). Revisa los errores abajo.',
      loadStopped: 'La carga se ha detenido por un error: {msg}. No se ha reintentado (para no duplicar lo ya cargado).',
      cantLeaveWhileRunning: 'No se puede salir mientras se está validando o cargando.',
      logValidateStart: '▶ Validando {n} filas en Sherpa…',
      logValidating: 'Validando filas {from}–{to}…',
      logValidateOk: '✓ {n} filas válidas',
      logValidateErrors: '⚠ {n} errores de validación',
      logLoadStart: '▶ Cargando {n} filas en Sherpa…',
      logLoading: 'Cargando filas {from}–{to}…',
      flowTitle: 'Proceso de carga',
      stageValidate: 'Validación',
      stageLoad: 'Carga',
      stageValidateIdle: 'Comprueba en el servidor que todas las filas cumplen la definición del formulario.',
      stageValidateOk: '{n} filas validadas · sin errores',
      stageValidateErrors: '{n} errores a corregir antes de guardar (tabla abajo)',
      stageLoadLocked: 'Se desbloquea cuando la validación salga sin errores.',
      stageLoadReady: 'Listo para guardar {n} respuestas en Sherpa.',
      techLog: 'Mostrar el log técnico',
      flowDone: 'Completado',
      colStatus: 'Estado',
      solvedCount: '{done} de {total} resueltos',
      hideResolved: 'Ocultar resueltos',
      resolved: 'Resuelto',
      pendingLabel: 'Pendiente',
      applySuggestion: 'Aplicar este valor del dominio',
      applyToSame: '↳ aplicar a {n} iguales',
      applyToSameTitle: 'Aplica «{value}» a todas las filas con «{orig}» en este campo ({n} más)',
      repeatedTitle: 'Este mismo valor falla en {n} filas más',
      errorsShowing: 'Mostrando {visible} de {total}',
      showMore: 'Mostrar más',
      downloadLoaded: '⬇ Excel de lo cargado',
      downloadExcel: '⬇ Descargar Excel',
      downloadServerErrors: '⬇ Descargar errores',
      excelError: 'No se ha podido generar el Excel.',
    },
    common: {
      next: 'Siguiente',
      prev: 'Anterior',
      cancel: 'Cancelar',
      yes: 'Sí',
      no: 'No',
      none: '—',
      exportCsv: 'Exportar CSV',
      showMore: 'Mostrar más',
      noEntries: '— Sin entradas con este filtro —',
      copyShort: '📋',
      copiedShort: '✓',
      copyErrorShort: '✗',
      copied: 'Copiado',
      hide: 'Ocultar',
      show: 'Mostrar',
      hideArrow: '▼',
      showArrow: '▶',
    },
    programs: {
      originComponent: 'programa en local',
      originModel: 'programa del modelo',
    },
    progAbm: {
      open: 'Programas y dependencias',
      title: 'Programas del componente',
      close: 'Cerrar',
      hint: 'Programas de corrección/cálculo guardados en el proyecto (standalonePrograms/). Se prueban sin guardarlos en el modelo; cuando validen, se promueven al catálogo del cliente.',
      newCorrection: 'Corrección', newCalculation: 'Cálculo',
      reload: 'Recargar', empty: 'Todavía no hay ningún programa de componente.',
      colName: 'Nombre', colType: 'Tipo', colScope: 'Alcance / alias',
      edit: 'Editar', delete: 'Borrar', badSource: 'código con errores',
      fName: 'Nombre (fichero)', fNamePlaceholder: 'letras, números, _ o -',
      fType: 'Tipo', fOrder: 'Orden', fDescription: 'Descripción',
      fScope: 'Alcance', fFieldTypes: 'Tipos de campo', fAliases: 'Alias',
      fMatchAll: 'Coincidencia de alias', matchAny: 'ALGUNO (basta con uno)', matchAll: 'TODOS (deben estar todos)',
      fAliasesPlaceholder: 'p.ej. individual_person_email, individual_person_name',
      fCode: 'Código (módulo JS: export default function create(ctx))',
      codeHint: 'Debe ser autocontenido (sin imports). run(out, fields) devuelve el array de propuestas.',
      cancel: 'Cancelar', save: 'Guardar',
      errName: 'El nombre solo puede tener letras, números, _ o -.',
      errCode: 'El código no es válido: {msg}.',
      confirmDelete: '¿Borrar el programa «{name}»?',
      tabPrograms: 'Programas', tabDeps: 'Dependencias',
      fDependencies: 'Dependencias',
      depsEmpty: 'No hay dependencias disponibles (créalas en la pestaña Dependencias).',
      aliasesLoad: 'Cargar alias del modelo', aliasesEmpty: 'Pulsa «Cargar alias del modelo».',
      aliasesError: 'No se pudieron cargar los alias: {msg}',
      depsHint: 'Datasets/JS reutilizables. Se cargan en ctx.deps de los programas que las referencian (json → objeto, js → módulo).',
      newDep: 'Dependencia', depsEmptyList: 'Todavía no hay ninguna dependencia.',
      colDepType: 'Tipo', depContent: 'Contenido', errJson: 'JSON no válido: {msg}.',
      depLocal: 'local', depModel: 'modelo', readonly: 'solo lectura',
    },
    settings: {
      title: 'Configuración de conexión a Sherpa',
      intro: 'Estos valores se guardan en el navegador (localStorage). Tienen prioridad sobre el .env. Si pones una URL absoluta (https://…) se contacta directamente; si la dejas vacía se usa el proxy de Vite.',
      profile: 'Cliente',
      language: 'Idioma',
      tokenEmpty: 'definido en el fichero del cliente',
      tokenHelp: 'El bearer se define en el fichero del cliente (config/<cliente>/client.config.js, campo token). Cambia de cliente en el selector para cargar el suyo.',
      baseUrl: 'URL del backend',
      baseUrlHint: 'Ejemplo: https://tu-servidor/sherpa/service/',
      baseUrlPlaceholder: 'vacío = proxy de dev → demo (sin CORS)',
      authScheme: 'Esquema de autenticación',
      authBearer: 'Authorization: Bearer …',
      authToken: 'Cabecera token: … (estilo SherpaCRM)',
      authNone: 'Sin autenticación',
      token: 'Token',
      tokenPlaceholder: 'eyJhbGciOi…',
      version: 'Cabecera version',
      versionPlaceholder: '4.0.0',
      testPath: 'Ruta de prueba',
      testPathHint: 'Endpoint que el botón «Probar conexión» visitará (relativo a la URL base). Por defecto: /forms.',
      testPathPlaceholder: 'ej: /forms o ruta-conocida-de-tu-Sherpa',
      effective: 'Configuración activa',
      effectiveMode: 'modo',
      effectiveFinalUrl: 'URL final',
      effectiveAuth: 'auth',
      effectiveToken: 'token',
      effectiveVersion: 'version',
      tokenDefined: '✓ definido',
      tokenNotDefined: '— no definido',
      modeDirect: 'directo (URL absoluta)',
      modeProxy: 'proxy /sherpa-api de Vite',
      test: 'Probar conexión',
      save: 'Guardar',
      clear: 'Borrar',
      show: 'Mostrar',
      hide: 'Ocultar',
      saved: 'Configuración guardada en el navegador.',
      cleared: 'Configuración local borrada (se vuelven a usar los valores de .env).',
      testItems: '{n} elementos',
      testResponse: 'respuesta recibida',
      testOK: 'OK · status {status} · {summary}',
      testError: 'Error {code}{status} · {msg} · ruta probada: {path}{cors}',
      corsHint: 'posible CORS o URL incorrecta — compruébalo en la consola del navegador',
    },
    swap: {
      title: '⇄ Posibles intercambios detectados',
      hint: 'Parece que estas columnas están cruzadas — el contenido encaja mejor con el campo del lado.',
      arrow: '↔',
      currently: 'actualmente: {fieldA} ← {columnA}, {fieldB} ← {columnB}',
      swapping: 'intercambiando: {pAB}% + {pBA}% encajan con el campo cruzado',
      swapButton: 'Intercambiar mapeo',
    },
    field: {
      closedDomain: 'dominio cerrado',
      smallSample: 'muestra pequeña',
      smallSampleTip: 'Pocos registros para decidir si el dominio es cerrado o abierto; carga más filas para fiarte.',
      group: 'Grupo:',
      copyTooltip: 'Copiar el campo y la muestra al portapapeles (TSV)',
      tsvFieldLabel: 'Campo',
      tsvTypeLabel: 'tipo',
      tsvGroupLabel: 'grupo',
      tsvFilledLabel: 'informados',
      tsvNullsLabel: 'nulos',
      tsvUniqueLabel: 'únicos',
      tsvClosedLabel: 'dominio cerrado',
      tsvHeader: 'VALOR\tCOUNT',
    },
  },
  en: {
    app: {
      title: 'File Transformation',
      subtitle: 'Prepare an external file before loading it into Sherpa',
    },
    nav: {
      upload: '1 · Upload',
      audit: '2 · Audit',
      form: '3 · Form',
      mapping: '4 · Mapping',
      values: '5 · Values',
      correction: '6 · Correction',
      computed: '7 · Computed fields',
      export: '8 · Export',
    },
    upload: {
      drop: 'Drop a CSV or XLSX file here',
      or: 'or',
      browse: 'Select a file',
      loaded: 'File loaded',
      change: 'Change file',
      encoding: 'Encoding',
      encodingAuto: 'detected',
      delimiter: 'Delimiter',
      delimiterAuto: 'Auto',
      multiSeparator: 'Multi-answer separator',
      multiSeparatorAuto: 'Auto',
      encodingPick: '— pick the encoding —',
      encodingUnknown: 'Could not detect the file encoding. Pick it manually to continue.',
      analyze: 'Analyze file',
      reset: 'Reset',
      analyzing: 'Analyzing the file…',
      phaseReading: 'Reading the file',
      phaseParsing: 'Parsing the file',
      phaseFields: 'Analyzing the fields',
      phaseGrouping: 'Semantic grouping',
      rowsUnit: 'rows',
      noData: 'The file has no data (header + rows).',
      xlsxLarge: 'This XLSX is large ({mb} MB). Parsing Excel in the browser is slow and may fail; for large files export it to CSV (much faster).',
      xlsxTooBig: 'Could not read this XLSX in the browser (likely too large). Export it to CSV and try again.',
      formats: 'Accepted formats: .csv, .xlsx (up to ~50.000 rows)',
    },
    audit: {
      summary: 'General summary',
      records: 'Records',
      fields: 'Fields',
      groups: 'Semantic grouping',
      perField: 'Per-field descriptor',
      download: 'Download Excel report',
      none: 'No file loaded yet',
      type: 'Type',
      informed: 'Filled',
      nulls: 'Null',
      unique: 'Unique',
      sample: 'Sample values',
      moreSample: 'and {count} more values',
      typeEmpty: 'Empty',
      typeBoolean: 'Boolean',
      typeNumber: 'Number',
      typeDate: 'Date',
      typeEmail: 'Email',
      typeText: 'Text',
      typeMixed: 'Mixed',
    },
    form: {
      title: 'Select the target form',
      search: 'Search by form name',
      load: 'Load definition',
      definition: 'Form definition',
      noDefinition: 'Select a form to view its definition',
      mandatory: 'Mandatory',
      optional: 'Optional',
      fromBackend: 'From Sherpa backend',
      fromFile: 'From an XLSX file',
      responses: 'responses',
      loadLang: 'Load language',
      pickLang: '— Pick a language —',
      pickLangHint: 'Pick the language to load the definition and continue',
      pickLangFirst: 'Pick the load language first',
      noBackend: 'Cannot access the Sherpa backend.',
      envHint: 'Check the Sherpa connection (URL and token) in the Settings bar; forms are loaded from Sherpa.',
      fileHint: 'Load the XLSX downloaded from Sherpa with the form definition (sheet "Definición de los campos").',
      pickFile: 'Select the XLSX file',
      loaded: 'Loaded:',
      colLabel: 'Label',
      colType: 'Type',
      colMinMax: 'Min / Max',
      colFormat: 'Format',
      colValidResponses: 'Valid responses',
      errAuthRequired: 'Authentication required',
      errCheckTokenAt: 'check the token at ⚙ Settings',
    },
    mapping: {
      refresh: '↻ Refresh proposal',
      needsPrev: 'Load a file and select a form before mapping.',
      fileColumns: 'File columns',
      mapped: 'Mapped',
      confHigh: 'High',
      confMedium: 'Medium',
      confLow: 'Low',
      confNone: 'None',
      filter: 'Filter by column or target field',
      onlyUnmapped: 'only unmapped',
      colColumn: 'File column',
      colField: 'Definition field',
      colConfidence: 'Confidence',
      colAction: 'Action',
      colValidation: 'Validation',
      missingMandatory: 'Mandatory fields with no source in file ({n})',
      missingMandatoryHint: 'No file column maps to these mandatory fields. You must set a value for every record: without one, the load into Sherpa will fail.',
      defaultModeNone: '—',
      defaultModeAuto: 'Auto value',
      autoValuePlaceholder: 'auto value',
      pickValue: '— pick a value —',
      fixedValuePlaceholder: 'value for every record',
      fillRequiredFirst: 'Fill in all mandatory fields with no source before continuing',
      requiredIncomplete: '{n} mandatory fields still need a value.',
      missingOptional: 'Optional fields with no source in file ({n})',
      missingOptionalHint: 'These form fields are not mapped to any column. You may set a value for every record if you want; if left empty, they simply won\'t be filled.',
      noMapping: '— no mapping —',
      searchField: 'Search field…',
      rowMandatory: 'mandatory',
      rowDomain: 'domain {n}',
      ignoreColumn: 'Ignore column',      errors: '{n} errors',
    },
    values: {
      proposeAuto: '✨ Auto-propose',
      propose: '✨ Propose',
      needsPrev: 'Complete the previous steps (Upload, Form, Mapping).',
      noClosedDomains: 'None of the mapped fields has a closed domain. No values need to be assigned.',
      fieldsWithDomain: 'Fields with domain',
      uniqueValues: 'Unique values',
      alreadyValid: 'Already valid',
      assigned: 'Assigned',
      pending: 'Pending',
      filter: 'Filter by field or value',
      hideValid: 'hide already-valid values',
      onlyWithPending: 'only fields with pending',
      sourceColumn: '· source column:',
      clearAssignments: 'Clear assignments',
      allowedValues: 'Allowed values:',
      colOriginal: 'Original value',
      colRepetitions: 'Repetitions',
      colState: 'State',
      colAssignedTo: 'Assigned to',
      alreadyValidState: '— already valid —',
      unassigned: '— unassigned —',
      stateValid: 'valid',
      stateAssigned: 'assigned',
      statePending: 'pending',
      noPendingValue: '— No pending value —',
    },
    correction: {
      recalculate: '↻ Recalculate proposals',
      pipelineTitle: 'Correction pipeline',
      programErrors: 'Program errors',
      needsPrev: 'Complete the previous steps (Upload, Audit, Form, Mapping).',
      rulesApplied: 'Applied rules',
      affectsAll: 'Affects: all mapped fields',
      affectsByType: 'Affects (by type):',
      affectsByAlias: 'Affects:',
      affectsNone: 'Affects: no field in this form',
      programsHint: 'Cleanup programs from the Sherpa catalog. Enable or disable the ones you want to apply.',
      restoreDefault: 'Restore defaults',
      pressRecalculate: 'Click «Recalculate proposals» to generate automatic corrections.',
      rulesNote: 'The engine applies only the rules ticked above. You can untick any rule you don\'t want to use for this run; the preference is saved in the browser for future files.',
      proposals: 'Proposals',
      accepted: 'Accepted',
      rejected: 'Rejected',
      filter: 'Filter by field, value or strategy',
      allStrategies: 'All strategies',
      showRejected: 'show rejected',
      acceptVisible: '✓ Accept visible',
      rejectVisible: '✕ Reject visible',
      afterApply: 'After applying the accepted corrections:',
      rowsWithErrors: 'Rows with errors',
      totalErrors: 'Total errors',
      colStrategy: 'Strategy',
      strategyMove: 'MOVE',
      strategySwap: 'SWAP',
      strategyReview: 'REVIEW',
      stepGeneric: 'General corrections',
      stepGenericHint: 'Applied to every field (whitespace, formatting, relocation between columns).',
      stepField: 'Field corrections',
      stepFieldHint: 'Applied only to specific fields by alias (e.g. email), on data already processed by the general step.',
      colStep: 'Step',
      allSteps: 'All steps',
      ruleTrim: 'Whitespace cleanup',
      ruleTrimDesc: 'Removes leading/trailing whitespace, collapses multiple spaces and strips invisible Unicode characters (BOM, zero-width).',
      ruleProperName: 'ProperName (case normalization)',
      ruleProperNameDesc: 'Converts text in all uppercase or all lowercase to ProperName format (JUAN PEREZ → Juan Perez). Mixed-case text is left untouched.',
      ruleDateFormat: 'Date format',
      ruleDateFormatDesc: 'Converts dates between formats (ISO, European dd/MM/yyyy, etc.) to the pattern the field expects.',
      ruleDomainMatch: 'Approximate domain match',
      ruleDomainMatchDesc: 'Looks for the closest value in a closed domain using prefix/suffix/Levenshtein (fixes typos like Tonsumer → consumer, profe → professional).',
      ruleRelocate: 'Relocate across fields',
      ruleRelocateDesc: 'Detects values placed in the wrong field (for example an email in the phone field) and proposes moving them to the right field if the destination cell is empty. If the destination already has a value, it is just flagged for manual review.',
      alreadyHasValue: '(already has value)',
      swapValueLabel: 'value:',
      noProposals: '— No proposals with these filters —',
      showingPagination: 'Showing {visible} of {total} ({hidden} hidden by pagination).',
    },
    computed: {
      recalculate: '↻ Recalculate',
      pipelineTitle: 'Compute pipeline',
      showTechLog: 'Show technical log',
      pipeline: {
        proposals: 'proposals',
        queued: 'queued',
        runningNow: 'running…',
        skipped: 'disabled',
        inProgress: 'in progress',
        done: 'done',
        typePreprocess: 'preprocess',
        typeCompute: 'compute',
        typeCorrection: 'correction',
      },
      recalculatePending: '↻ Recalculate (pending)',
      running: 'Running…',
      runningAtomic: 'Processing…',
      console: 'Execution console',
      clearConsole: 'Clear',
      cantLeaveWhileRunning: 'You cannot move to the next step while programs are running. Wait for them to finish.',
      needsPrev: 'Complete the previous steps (Upload, Form, Mapping).',
      programsAvailable: 'Available programs',
      configChanged: 'Configuration changed · click <strong>Recalculate</strong>',
      noCalculator: 'No calculator available.',
      restoreDefaultShort: 'restore default',
      requiredFields: 'Required fields:',
      pickFieldHint: 'Pick a field for each selector so the calculation can apply.',
      pressRecalculate: 'Click «Recalculate» to generate proposals.',
      basedOnCorrection: 'Operates on the result of the Correction step. You can go back if you want to adjust mappings or rules.',
      proposals: 'Proposals',
      accepted: 'Accepted',
      rejected: 'Rejected',
      filter: 'Filter by field, value, reason or calculator',
      allCalculators: 'All calculators',
      showRejected: 'show rejected',
      acceptVisible: '✓ Accept visible',
      rejectVisible: '✕ Reject visible',
      afterAccepted: 'After applying the accepted computations:',
      rowsWithErrors: 'Rows with errors',
      totalErrors: 'Total errors',
      changesSummary: 'Changes summary',
      changesSummaryHint: 'Accepted proposals grouped by program and change type (same field and same values). Big-picture view; the row-by-row detail is in «Proposals».',
      proposalsHint: 'Main table: each proposed change, row by row, with the reason and the accept/reject checkbox. The «Changes summary» above is its aggregated (collapsed) version.',
      colProgram: 'Program',
      byProgram: 'By program:',
      fromProgram: 'Program:',
      typePreprocess: 'Preprocess',
      typeCompute: 'Compute',
      colRows: 'Rows',
      noEntries: '— No entries with this filter —',
      showMore: 'Show more',
      colRow: 'Row',
      colField: 'Field',
      colOriginal: 'Original',
      colProposed: 'Proposed',
      colDataOrigin: 'Origin data',
      colDataOutput: 'Output data',
      colReason: 'Reason',
      colAccept: 'Accept',
      showingProposals: 'Showing {visible} of {total} ({hidden} hidden by pagination).',
      copied: '✓ Copied',
      copyError: '✗ Error',
      copy: '📋 Copy',
    },
    export: {
      needsPrev: 'Complete the previous steps (upload file, select form and map).',
      rows: 'Rows',
      rowsWithErrors: 'Rows with errors',
      totalErrors: 'Total errors',
      errorsDetected: 'Errors detected (first {n} rows)',
      colRow: 'Row',
      colField: 'Field',
      colCode: 'Code',
      colValue: 'Value',
      colExpected: 'Expected',
      downloadXlsx: '⬇ Download transformed XLSX',
      uploadToSherpa: '☁ Upload to Sherpa',
      uploading: 'Uploading…',
      colMessage: 'Problem',
      moreCount: '… (+{n} more)',
      uploadOK: 'Upload completed',
      uploadError: 'Load error',
      validate: '✓ Validate in Sherpa',
      validating: 'Validating…',
      save: '☁ Save to Sherpa',
      saving: 'Saving…',
      revalidate: '↻ Re-validate',
      allValid: 'All valid ({n} rows). You can save.',
      serverErrors: 'Validation errors ({n})',
      serverErrorsHint: 'Fix the values here and re-validate. Nothing is saved until there are no errors.',
      editsCount: '{n} fixes',
      precheck: 'Pre-check (local validation — first {n} rows)',
      loadedOk: '✓ Loaded {n} responses into Sherpa.',
      noRecords: 'There are no rows to validate/load (0 records). Check the mapping and corrections: the pipeline output is empty.',
      loadedWithErrors: 'The load returned {errors} server error(s) (loaded {loaded}). Review the errors below.',
      loadStopped: 'Load stopped on error: {msg}. Not retried (to avoid duplicating already-loaded rows).',
      cantLeaveWhileRunning: 'Cannot leave while validating or loading.',
      logValidateStart: '▶ Validating {n} rows in Sherpa…',
      logValidating: 'Validating rows {from}–{to}…',
      logValidateOk: '✓ {n} valid rows',
      logValidateErrors: '⚠ {n} validation errors',
      logLoadStart: '▶ Loading {n} rows into Sherpa…',
      logLoading: 'Loading rows {from}–{to}…',
      flowTitle: 'Load process',
      stageValidate: 'Validation',
      stageLoad: 'Load',
      stageValidateIdle: 'Checks on the server that every row matches the form definition.',
      stageValidateOk: '{n} rows validated · no errors',
      stageValidateErrors: '{n} errors to fix before saving (table below)',
      stageLoadLocked: 'Unlocks once validation passes with no errors.',
      stageLoadReady: 'Ready to save {n} responses to Sherpa.',
      techLog: 'Show technical log',
      flowDone: 'Done',
      colStatus: 'Status',
      solvedCount: '{done} of {total} solved',
      hideResolved: 'Hide solved',
      resolved: 'Solved',
      pendingLabel: 'Pending',
      applySuggestion: 'Apply this domain value',
      applyToSame: '↳ apply to {n} alike',
      applyToSameTitle: 'Apply «{value}» to all rows with «{orig}» in this field ({n} more)',
      repeatedTitle: 'This same value fails in {n} more rows',
      errorsShowing: 'Showing {visible} of {total}',
      showMore: 'Show more',
      downloadLoaded: '⬇ Loaded Excel',
      downloadExcel: '⬇ Download Excel',
      downloadServerErrors: '⬇ Download errors',
      excelError: 'Could not generate the Excel.',
    },
    common: {
      next: 'Next',
      prev: 'Previous',
      cancel: 'Cancel',
      yes: 'Yes',
      no: 'No',
      none: '—',
      exportCsv: 'Export CSV',
      showMore: 'Show more',
      noEntries: '— No entries with this filter —',
      copyShort: '📋',
      copiedShort: '✓',
      copyErrorShort: '✗',
      copied: 'Copied',
      hide: 'Hide',
      show: 'Show',
      hideArrow: '▼',
      showArrow: '▶',
    },
    programs: {
      originComponent: 'local program',
      originModel: 'model program',
    },
    progAbm: {
      open: 'Programs & dependencies',
      title: 'Component programs',
      close: 'Close',
      hint: 'Correction/calculation programs stored in the project (standalonePrograms/). Test them without saving to the model; once validated, promote them to the client catalog.',
      newCorrection: 'Correction', newCalculation: 'Calculation',
      reload: 'Reload', empty: 'No component programs yet.',
      colName: 'Name', colType: 'Type', colScope: 'Scope / aliases',
      edit: 'Edit', delete: 'Delete', badSource: 'code has errors',
      fName: 'Name (file)', fNamePlaceholder: 'letters, digits, _ or -',
      fType: 'Type', fOrder: 'Order', fDescription: 'Description',
      fScope: 'Scope', fFieldTypes: 'Field types', fAliases: 'Aliases',
      fMatchAll: 'Alias match', matchAny: 'ANY (at least one)', matchAll: 'ALL (all required)',
      fAliasesPlaceholder: 'e.g. individual_person_email, individual_person_name',
      fCode: 'Code (JS module: export default function create(ctx))',
      codeHint: 'Must be self-contained (no imports). run(out, fields) returns the proposals array.',
      cancel: 'Cancel', save: 'Save',
      errName: 'Name may only contain letters, digits, _ or -.',
      errCode: 'Invalid code: {msg}.',
      confirmDelete: 'Delete program “{name}”?',
      tabPrograms: 'Programs', tabDeps: 'Dependencies',
      fDependencies: 'Dependencies',
      depsEmpty: 'No dependencies available (create them in the Dependencies tab).',
      aliasesLoad: 'Load model aliases', aliasesEmpty: 'Click “Load model aliases”.',
      aliasesError: 'Could not load aliases: {msg}',
      depsHint: 'Reusable datasets/JS. Loaded into ctx.deps of the programs that reference them (json → object, js → module).',
      newDep: 'Dependency', depsEmptyList: 'No dependencies yet.',
      colDepType: 'Type', depContent: 'Content', errJson: 'Invalid JSON: {msg}.',
      depLocal: 'local', depModel: 'model', readonly: 'read-only',
    },
    settings: {
      title: 'Sherpa connection settings',
      intro: 'These values are saved in the browser (localStorage) and override .env. If you put an absolute URL (https://…) the app contacts the backend directly; otherwise it uses the Vite proxy.',
      profile: 'Client',
      language: 'Language',
      tokenEmpty: 'defined in the client file',
      tokenHelp: 'The bearer is defined in the client file (config/<client>/client.config.js, token field). Switch client in the selector to load its token.',
      baseUrl: 'Backend URL',
      baseUrlHint: 'Example: https://your-server/sherpa/service/',
      baseUrlPlaceholder: 'empty = dev proxy → demo (no CORS)',
      authScheme: 'Auth scheme',
      authBearer: 'Authorization: Bearer …',
      authToken: 'token header: … (SherpaCRM style)',
      authNone: 'No authentication',
      token: 'Token',
      tokenPlaceholder: 'eyJhbGciOi…',
      version: 'Version header',
      versionPlaceholder: '4.0.0',
      testPath: 'Test path',
      testPathHint: 'Endpoint visited by the «Test connection» button (relative to the base URL). Defaults to /forms.',
      testPathPlaceholder: 'e.g. /forms or known-path-of-your-Sherpa',
      effective: 'Active configuration',
      effectiveMode: 'mode',
      effectiveFinalUrl: 'Final URL',
      effectiveAuth: 'auth',
      effectiveToken: 'token',
      effectiveVersion: 'version',
      tokenDefined: '✓ defined',
      tokenNotDefined: '— not defined',
      modeDirect: 'direct (absolute URL)',
      modeProxy: 'Vite /sherpa-api proxy',
      test: 'Test connection',
      save: 'Save',
      clear: 'Clear',
      show: 'Show',
      hide: 'Hide',
      saved: 'Settings saved in browser.',
      cleared: 'Local settings cleared (the .env values will be used again).',
      testItems: '{n} items',
      testResponse: 'response received',
      testOK: 'OK · status {status} · {summary}',
      testError: 'Error {code}{status} · {msg} · path tried: {path}{cors}',
      corsHint: 'possible CORS or wrong URL — check the browser console',
    },
    swap: {
      title: '⇄ Possible swaps detected',
      hint: 'These columns may be crossed — their content matches better with the neighbor field.',
      arrow: '↔',
      currently: 'currently: {fieldA} ← {columnA}, {fieldB} ← {columnB}',
      swapping: 'swapping: {pAB}% + {pBA}% fit the crossed field',
      swapButton: 'Swap mapping',
    },
    field: {
      closedDomain: 'closed domain',
      smallSample: 'small sample',
      smallSampleTip: 'Too few records to tell whether the domain is closed or open; load more rows to be sure.',
      group: 'Group:',
      copyTooltip: 'Copy the field and sample to clipboard (TSV)',
      tsvFieldLabel: 'Field',
      tsvTypeLabel: 'type',
      tsvGroupLabel: 'group',
      tsvFilledLabel: 'filled',
      tsvNullsLabel: 'nulls',
      tsvUniqueLabel: 'unique',
      tsvClosedLabel: 'closed domain',
      tsvHeader: 'VALUE\tCOUNT',
    },
  },
};
